"use strict";
//Russian
const messages = {
  'ALERT-MIC': 'Missing Microphone',
  'ALERT-SPEAKER': 'Missing Speaker',
  'AUDIOCONTROLS-INPUT-HEADING': 'Вход',
  'AUDIOCONTROLS-OUTPUT-HEADING': 'Вывод',
  'AUDIOCONTROLS-CANCEL-BTN-LABEL': 'Отмена',
  'AUDIOCONTROLS-SAVE-BTN-LABEL': 'Сохранить',
  'BACK-BTN-LABEL': 'Hазад',
  'CALLCONTROLS-MUTE-BTN-LABEL' : 'Mикpoфoн',
  'CALLCONTROLS-HOLD-BTN-LABEL' : 'Удержать',
  'CALLCONTROLS-AUDIO-BTN-LABEL' : 'Аудио',
  'CALLCONTROLS-KEYPAD-BTN-LABEL' : 'Клавиатура',
  'CALLCONTROLS-TRANSFER-BTN-LABEL' : 'Перевод',
  'CALLCONTROLS-NEWCALL-BTN-LABEL' : 'Позвонить',
  'CALLCONTROLS-HANGUP-BTN-LABEL' : 'Повесить Трубку',
  'CALLLIST-NOCALL' : 'Нет Активных Вызовов',
  'CANCEL-BTN-LABEL' : 'Отмена',
  'EMAIL-PLACEHOLDER' : 'Адрес электронной почты',
  'INCOMINGCALL-HEADER' : 'Входящий звонок',
  'INCOMINGCALL-ACCEPT' : 'Oтввтить',
  'INCOMINGCALL-DECLINE' : 'Oткпониь',
  'INCOMINGCALL-VOICEMAIL' : 'Отправить на голосовую почту',
  'LOGIN-INPUT-EMAIL-PLACEHOLDER' :' Эл. адрес',
  'LOGIN-INPUT-PASSWORD-PLACEHOLDER' : 'Введите пароль',
  'LOGIN-CHECKBOX-LABEL' : 'Запомни меня',
  'LOGIN-FORGOTPASSWORD-LINK' : 'Забыли пароль?',
  'LOGIN-SIGNIN-BTN-LABEL' : 'Войти в систему',
  'LOGIN-FORGOTPW-INFO-TEXT' : 'Введите свой адрес электронной почты для восстановления пароля.',
  'LOGIN-INPUT-PASSWORD-ERROR' : 'Пожалуйста, введите полный пароль',
  'LOGIN-INPUT-EMAIL-ERROR' : 'Пожалуйста, введите действительный адрес электронной почты',
  'LOGIN-RESETPW-INPUT-PASSWORD-ERROR': 'Пароли должны совпадать',
  'LOGIN-FORGOTPW-RESETPASSWORD-BTN-LABEL' : 'Сброс',
  'LOGIN-RESETPW-INFO-TEXT' : ', Пожалуйста, измените пароль. Пароль должен содержать хотя бы одну букву, не содержать пробелов, не начинается с @, и  содержать 8 или более символов.',
  'LOGIN-RESETPW-INPUT-PASSWORD-PLACEHOLDER' : 'Новый пароль',
  'LOGIN-RESETPW-INPUT-REPEATPASSWORD-PLACEHOLDER' : 'Повторите пароль',
  'LOGIN-RESETPW-CHANGE-BTN-LABEL' : 'Изменить',
  'LOGIN-RESETPW-NOTNOW-BTN-LABEL' : 'Отмена',
  'SETTINGS-VIEWALERT-BTN-LABEL' : 'Просмотр Oповещений',
  'SETTINGS-VERSION' : 'версия ',
  'SETTINGS-HELPDOC-BTN-LABEL' : 'Помощь Документация',
  'SETTINGS-CHECKBOX-LABEL' : 'Bключить',
  'SETTINGS-CHECKBOX-HEADER' : 'Поверх Окон?',
  'SETTINGS-CLOSEALERTS-BTN-LABEL' : 'Закрыть оповещения',
  'SETTINGS-LOGOUT-BTN-LABEL' : 'Выйти',
  'SETTINGS-SELECT-EXTENSION-HEADER': 'Pасширение',
  'SETTINGS-SELECT-RINGTONE-HEADER': 'Мелодия',
  'SETTINGS-SELECT-INPUTDEVICE-HEADER': 'Устройство Bвода',
  'SETTINGS-SELECT-OUTPUTDEVICE-HEADER': 'Устройство Bывода',
  'SETTINGS-SELECT-INTERFACETHEME-HEADER': 'Tема Интерфейса',
  'SETTINGS-SELECT-INTERFACELANGUAGE-HEADER': 'Язык Интерфейса',
  'CALLHISTORY-BACK-BTN-LABEL' : 'Назад',
  'CALLHISTORY-CLEAR-HISTORY-BTN-LABEL' : 'Oчиcтить',
  'CALLHISTORY-HEADER' : 'История',
  'CALLHISTORY-NO-HISTORY-MSG' : 'Нет Истории Звонков',
  'ALERTLOG-SETTINGS-BTN-LABEL' : 'Назад',
  'ALERTLOG-CLEAR-ALERT-BTN-LABEL' : 'Очиcтить',
  'ALERTLOG-HEADER' : 'Оповещения',
  'ALERTLOG-NO-ALERT-MSG' : 'Нет Доступных Оповещений',
  'UTILITIES-STATUS-ONHOLD' : 'На удерживании',
  'UTILITIES-STATUS-MUTED' : 'Приглушенный',
  'UTILITIES-STATUS-ACTIVE' : 'Aктивный',
  'UTILITIES-STATUS-DIALING' : 'Hабор Hомера',
  'ALERTITEM-HEADING-LOGIN' : 'Авторизоваться',
  'ALERTITEM-BODY-INCORRECT-CREDENTIALS-MSG' : 'Неверное имя пользователя или пароль.',
  'ALERTITEM-HEADING-LOST-NETWORK-CONNECTION' : 'Потеря  сетевого подключения. Проверьте состояние подключения.',
  'DIALINPUT-PLACEHOLDER-TEXT' : 'Введите номер для вызова',
  'CALLDETAILS-HOLD' : 'На удерживании',
  'CALLDETAILS-MUTED': 'Приглушенный',
  'CALLLIST-STATUS-ACTIVE': 'Активный',
  'CALLLIST-STATUS-DIALING': 'Набор номера',
  'CALLHISTORY-STATUS-FAILED': 'Не смогли',
  'HEADING-STATUS-CONNECTED' : 'B Cети',
  'HEADING-STATUS-OFFLINE' : 'Не в сети',
  'BLIND-BTN-LABEL': 'Слепой',
  'ATTENDED-BTN-LABEL': 'Подтвержденный',
  'SOFTPHONE-DTMF-COMMANDS': "Введите номер",
  'ARIA-LOGIN-SIGNIN-BTN': "Вход на кнопку",
  'ARIA-LOGIN-FORGOTPASSWORD-BTN': "Забыл пароль Кнопка",
  'ARIA-CANCEL-BTN': "Кнопка Отмена",
  'ARIA-LOGIN-FORGOTPW-RESETPASSWORD-BTN': "Кнопка сброса пароля",
  'ARIA-LOGIN-RESETPW-NOTNOW-BTN-LABEL': "Не сейчас кнопка",
  'ARIA-CALLHISTORY-BACK-BTN-LABEL': 'Кнопка назад',
  'ARIA-CALLHISTORY-CLEAR-HISTORY-BTN-LABEL': 'Кнопка Очистить историю',
  'ARIA-SETTINGS-LOGOUT-BTN': "Кнопка Выход",
  'ARIA-SETTINGS-VIEWALERT-BTN': "Кнопка Просмотр предупреждений",
  'ARIA-SETTINGS-HELPDOC-BTN': "Помощь кнопка документация",
  'ARIA-RESETPW-CHANGE-BTN-LABEL': "Кнопка Изменить пароль",
  'ARIA-BACKSPACE-BTN': 'кнопка Backspace',
  'ARIA-DIALING-INPUT-FIELD': 'Набор поле ввода',
  'ARIA-HEADER': 'Заголовок',
  'ARIA-CLEAR-ALERTS-BUTTON': 'Кнопка Очистить оповещения',
  'ARIA-ALERT-LIST': 'Список оповещений',
  'ARIA-CHECKBOX': 'Флажок',
  'ARIA-SAVE-BTN': 'Кнопка Сохранить',
  'ARIA-INPUT-FIELD': 'Поле ввода',
  'ARIA-INPUT': 'Вход',
  'ARIA-KEYPAD': 'Клавиатура',
  'ARIA-KEY': 'Ключ',
  'ARIA-AUDIO-SLIDER': 'Аудио слайдер',
  'ARIA-AUDIO-SLIDER-CONTROL': 'Аудио управления слайдер',
  'ARIA-MENU-ITEM': 'Пункт меню',
  'ARIA-DROP-DOWN-MENU': 'Выпадающее меню',
  'ARIA-BADGE-BUTTON': 'Кнопка Значок',
  'ARIA-CALL-DETAIL': 'Детализированный',
  'ARIA-OPEN-SETTINGS-BUTTON': 'Кнопка Открыть настройки',
  'UPDATE-HEADER': 'Доступно обновление',
  'UPDATE-MSG': 'Вы хотите, чтобы приложение перезапустилось сейчас?',
  'UPDATE-POSTPONE-BUTTON': 'Отложите (1 мин)',
  'UPDATE-UPDATE-BUTTON': 'Обновить',
  'ARIA-UPDATE-POSTPONE-BUTTON': 'Отложите Button',
  'ARIA-UPDATE-UPDATE-BUTTON': 'Кнопка Update',
  'ACTIVECALL-STATUS-RINGING': 'Звонкий',
  'ACTIVECALL-STATUS-ACTIVE': 'Активный',
  'ACTIVECALL-STATUS-DIALING': 'Набор номера',
  'ACTIVECALL-STATUS-FAILED': 'Не смогли',
  'LOGIN-INPUT-SHOW': 'Показать',
  'LOGIN-INPUT-HIDE': 'Спрятать',
  'CALLHISTORY-TODAY': 'Cегодня',
  'CALLHISTORY-YESTERDAY': 'Вчера',
  'ALERT_FORGOT_PASSWORD': 'Забыли пароль',
  'ALERT_SETTINGS_WILL_APPLY': 'Активные звонки; настройки будут применяться в режиме ожидания.',
  'ALERT_DIALING_OPTIONS': 'Параметры набора номера',
  'ALERT_DIALING_OPTIONS_BODY': 'Отсутствующие параметры абонентской группы',
  'ALERT_LOGIN': 'Авторизоваться',
  'ALERT_SOFTPHONE_EXTENSION': 'Нет расширения софтфон',
  'ALERT_MORE_INFORMATION': 'Для получения дополнительной информации посетите сайт:',
  'ALERT_LOST_CONNECTION': 'Потеря  сетевого подключения. Проверьте состояние подключения.',
  'ARIA-PLAY-BTN': 'Кнопка воспроизведения',
  'ARIA-STOP-BTN': 'Кнопка остановки',
  'CONTACTS-STATUS-ONLINE': 'В сети',
  'CONTACTS-STATUS-OFFLINE': 'Не в сети',
  'CONTACTS-STATUS-BUSY': 'Занятый',
  'CONTACTS-STATUS-UNKNOWN': 'Неизвестный',
  'LABELLEDINPUT-LABEL-EMAIL': "Адрес электронной почты",
  'LABELLEDINPUT-LABEL-PASSWORD': "пароль",
  'LABELLEDINPUT-LABEL-TEXT': "Текст",
  'LABELLEDINPUT-HINT-EMAIL': "Введите действующий адрес электронной почты ниже.",
  'LABELLEDINPUT-HINT-PASSWORD': "Введите действующий пароль ниже.",
  'LABELLEDINPUT-HINT-TEXT': "Введите текст ниже.",
  'ARIA-ICON-AREA': 'Область значков',
  'SETTINGS-ADVANCED-LOGGING': "Расширенное ведение журнала",
  'APPMENU-SETTINGS-BTN-LABEL': "Открыть настройки",
  'APPMENU-HELP-BTN-LABEL': "Справочная документация",
  'APPMENU-LOGOUT-BTN-LABEL': "Выйти",
  'APPMENU-VERSION': "версия ",
  'HEADER-SETTINGS-TITLE': "настройки",
  'SETTINGS-NOTIFICATIONS-BTN-LABEL': "Уведомления",
  'SETTINGS-APPEARANCE-BTN-LABEL': "Внешность",
  'SETTINGS-CONTACTS-BTN-LABEL': "контакты",
  'SETTINGS-TROUBLESHOOTING-BTN-LABEL': "Исправление проблем.",
  'SETTINGS-NOTIFICATIONS-BTN-DESCRIPTION': "Отрегулируйте, как вы получаете обновления.",
  'SETTINGS-APPEARANCE-BTN-DESCRIPTION': "Измените внешний вид приложения.",
  'SETTINGS-CONTACTS-BTN-DESCRIPTION': "Импортируйте свои контакты.",
  'SETTINGS-TROUBLESHOOTING-BTN-DESCRIPTION': "Инструменты, которые помогут вам выяснить, что не так",
  'ARIA-BACK-BTN-LABEL': "Hазад",
  'HEADER-BACK-ARIA-LABEL' : 'назад',
  'ENTITYLIST-SEARCH-FOUND': "найденный.",
  'ENTITYLIST-SEARCH-ITEM-PLURAL': "Предметы",
  'ARIA-EVENT-LIST-ADD-NEW-GROUP': 'Новая группа',
  'ENTITYLIST-NO-CONTACTS-FOUND': 'Контакты не найдены',
  'ENTITYLIST-TRY-IMPORTING': 'Попробуйте импортировать или добавить контакт.',
  'ZEROSTATE-IMPORT-BTN-LABEL': 'Импортировать',
  'ENTITYLIST-NO-CONTACTS-DESCRIPTION': 'Введите номер для отправки или импорта списка контактов в настройках.',
  'ENTITYLIST-SEARCHBAR-SEARCH-CONTACTS': "Поиск контактов",
  'CONTACT-DETAILS-CARD-ZERO-STATE-BUTTON-LABEL' : 'Добавить номер',
  'CONTACT-DETAILS-CARD-ZERO-STATE-TITLE': 'Нет контактной информации',
  'CONTACT-DETAILS-CARD-ZERO-STATE-DESCRIPTION': 'Добавить число, чтобы начать',
  'ARIA-CARD-DETAILS-EDIT': 'редактировать',
  'ARIA-CARD-DETAILS-DELETE': 'Удалить',
  'SETTINGS-DEVICES-BTN-LABEL': "приборы",
  'SETTINGS-DEVICES-BTN-DESCRIPTION': "Измените настройки устройств.",
  'HEADER-CONTACTS-ARIA-LABEL' : "контакты",
  "SETTINGS-CATEGORY-HEADER-TROUBLESHOOTING": "Исправление проблем",
  "SETTINGS-TROUBLESHOOTING-CHECKBOX-LABEL": "Включить расширенную регистрацию",
  "SETTINGS-TROUBLESHOOTING-DESCRIPTION" : "Когда включено, приложение создаст расширенные журналы, чтобы помочь в диагностике ошибок приложения.",
  "SETTINGS-ADVANCED-LOGGING-TITLE" : 'Расширенный журнал',
  'SETTINGS-CATEGORY-HEADER-ALERTS': "Оповещения",
  "SETTINGS-VIEW-ALERTS-TITLE" : "Просмотр предупреждений",
  "SETTINGS-VIEW-ALERTS-DESCRIPTION": "Доступ к записи предупреждений и журналов.",
  "SETTINGS-NOTIFICATIONS-TITLE": "Звук звонка",
  "SETTINGS-NOTIFICATIONS-DESCRIPTION": "Изменение мелодии звонка для входящих голосовых вызовов.",
  'APPMENU-DEFAULT-THEME-BTN-LABEL': "о умолчанию",
  'APPMENU-LIGHT-THEME-BTN-LABEL': "Легкий",
  'APPMENU-DARK-THEME-BTN-LABEL': "Темно",
  'SETTINGS-APPEARANCE-TITLE-ALWAYS-ON-TOP': "Всегда на вершине",
  'SETTINGS-ALWAYS-ON-TOP-DESCRIPTION': "Когда включено, приложение всегда будет отображаться над другими вашими приложениями.",
  'SETTINGS-APPEARANCE-CHECKBOX-LABEL': "Всегда на вершине?",
  'SETTINGS-APPEARANCE-TITLE-THEME': "тема",
  'SETTINGS-THEMES-DESCRIPTION': "Темы меняют общий внешний вид приложения.",
  'SETTINGS-APPEARANCE-TITLE-LANGUAGE': "Язык.",
  'SETTINGS-LANGUAGE-DESCRIPTION': "CИзменение языка меняет его во всем приложении.",
  'SETTINGS-CATEGORY-HEADER-DEVICE': "устройство",
  "SETTINGS-CATEGORY-HEADER-NOTIFICATIONS" : "Исправление проблем",
  "SETTINGS-CATEGORY-HEADER-APPEARANCE" : "Внешность",
  "SETTINGS-CATEGORY-HEADER-CONTACTS" : "контакты",
  'SETTINGS-INPUT-DEVICE-TITLE': "Устройство ввода",
  'SETTINGS-INPUT-DEVICE-DESCRIPTION': "Установите аудиоустройство, которое вы хотите использовать для ввода.",
  'SETTINGS-OUTPUT-DEVICE-TITLE': "Устройство вывода",
  'SETTINGS-OUTPUT-DEVICE-DESCRIPTION': "Установите аудиоустройство, которое вы хотите использовать для вывода.",
  'SETTINGS-CONTACTS-IMPORT-YOUR-CONTACTS': "Импорт ваших контактов",
  'SETTINGS-CONTACTS-IMPORT-CONTACTS-DESCRIPTION': "Чтобы импортировать контакты, выберите свой вариант ниже.",
  'SETTINGS-CONTACTS-SAMPLE-CSV': "Пример CSV",
  'SETTINGS-CONTACTS-DOWNLOAD-SAMPLE-CSV-DESCRIPTION': "Нажав кнопку ниже, вы загрузите образец файла CSV.",
  'SETTINGS-CONTACTS-BACKUP': 'Резервное копирование',
  'SETTINGS-CONTACTS-DOWNLOAD-SAMPLE-CSV-BUTTON': 'Загрузить образец',
  'SETTINGS-CONTACTS-DOWNLOAD-BACKUP-CSV-DESCRIPTION': "Нажав кнопку ниже, вы загрузите резервную копию своих CSV-архивов. Это рекомендуется перед импортом.",
  'SETTINGS-IMPORT-LAST-SYNC-LABEL': "импортный",
  'SETTINGS-IMPORT-CONTACTS-SOURCES-BUTTON': "Импортировать",
  'SETTINGS-CONTACTS-DOWNLOAD-BACKUP-CSV-BUTTON': 'Скачать Резервное копирование',
  'ZEROSTATE-ADD-CONTACT-BTN-LABEL': 'Добавить контакт',
  'CONTACT-DETAILS-CARD-MODAL-CANCEL-BUTTON': "Отмена",
  'CONTACT-DETAILS-CARD-MODAL-DELETE-BUTTON': "Удалить",
  'CONTACT-DETAILS-CARD-MODAL-HEADER-DELETE-CONTACT' : "Вы уверены, что хотите удалить этот контакт?",
  'CONTACT-DETAILS-CARD-MODAL-DESCRIPTION-DELETE-CONTACT': "Завершение этого действия навсегда удалит информацию о текущем контакте. ",
  'CONTACT-DETAILS-FORM-ERROR': 'Поле в форме ниже имеет ошибку.',
  'CONTACT-DETAILS-FORM-PERSONAL-INFO-HEADER': 'Личная информация',
  'CONTACT-DETAILS-FORM-FIRST-NAME-HEADER': 'Имя',
  'CONTACT-DETAILS-FORM-FIRST-NAME-PLACEHOLDER': 'Введите имя',
  'CONTACT-DETAILS-FORM-LAST-NAME-HEADER': 'фамилию',
  'CONTACT-DETAILS-FORM-LAST-NAME-PLACEHOLDER': 'Введите фамилию',
  'CONTACT-DETAILS-FORM-COMPANY-NAME-HEADER': 'Компания',
  'CONTACT-DETAILS-FORM-COMPANY-NAME-PLACEHOLDER': 'Введите название компании',
  'CONTACT-DETAILS-FORM-PHONE-NUMBERS-HEADER': 'Телефонные номера',
  'CONTACT-DETAILS-FORM-PHONE-BTN-LABEL': 'Добавить телефон',
  'CONTACT-DETAILS-FORM-CANCEL-BTN-LABEL': 'Отмена',
  'CONTACT-DETAILS-FORM-SAVE-BTN-LABEL': 'Сохранить',
  'CONTACT-DETAILS-FORM-NEW-CONTACT-HEADER': 'Новый контакт',
  'CONTACT-DETAILS-FORM-EDIT-CONTACT-HEADER': 'Изменить контакт',
  'CONTACT-DETAILS-FORM-INPUT-ERROR': 'Это поле не может быть пустым.',
  'CONTACT-DETAILS-FORM-NUMBER-HEADER':'Число',
  'CONTACT-DETAILS-FORM-NUMBER-ERROR':'Введите действительное 10-значное число',
  'CONTACT-DETAILS-FORM-NUMBER-PLACEHOLDER':'Введите номер...',
  'CONTACT-DETAILS-FORM-PREFERRED-LABEL':'Предпочтительный?',
  'CONTACT-DETAILS-FORM-SELECT-HOME': 'Главная',
  'CONTACT-DETAILS-FORM-SELECT-BUSINESS': 'Бизнес',
  'CONTACT-DETAILS-FORM-SELECT-MOBILE': 'мобильный',
  'CONTACT-DETAILS-FORM-SELECT-OTHER': 'Другие',
  'CONTACT-DETAILS-FORM-SELECT-LABEL': 'метка',
  'NUMBER-SELECTION-MODAL-SELECT-NUMBER-TO-CALL': 'Выберите номер для вызова',
  'NUMBER-SELECTION-MODAL-PREFERRED': 'Предпочтительные',
  'CONTACT-DETAILS-FORM-NUMBER-ERROR-PROP':'Введите действительное число'
};
module.exports = messages;



// WEBPACK FOOTER //
// ./src/locales/locale-ru.js